export const trainLevels = [
    10,
    12,
    15,
    20,
    25,
    30,
    40,
    50,
    65,
    75,
    90,
    100,
    120,
    140,
    165,
    195,
    220,
    250,
    280,
    320,
    350,
    380,
    420,
    460,
    510,
    560,
    610,
    660,
    710,
    750,
];

const getCumulativeLevelRequirement = (level: number) => {
    let sum = 0;
    for (let i = 0; i < level; i++) {
        sum += trainLevels[i];
    }

    return sum;
}

export const cumulativeLevels = trainLevels.map((l, i) => getCumulativeLevelRequirement(i + 1));

export const getLevelFromDonationSum = (sum: number) => {
    const idx = cumulativeLevels.findIndex(l => sum < l);

    if (idx === -1) {
        return trainLevels.length;
    }

    return idx + 1;
}